import request from '@/utils/request'
import requestJson from '@/utils/requestJson'

export function login(data) {
  return request({
    url: '/admin/login/check',
    method: 'post',
    data
  })
}


export function loginOut(data) {
  return request({
    url: '/admin/login/out',
    method: 'get',
    params: data
  })
}

export function superLogin(data) {
  return request({
    url: '/admin/login/sudo',
    method: 'post',
    data
  })
}


export function sleepGetList(data) {
  return request({
    url: '/admin/pospal/getList',
    method: 'get',
    params: data
  })
}

export function sleepGetOne(data) {
  return request({
    url: '/admin/pospal/getOne',
    method: 'get',
    params: data
  })
}

export function pospalDel(data) {
  return request({
    url: '/admin/pospal/del',
    method: 'get',
    params: data
  })
}

export function pospalUp(data) {
  return requestJson({
    url: '/admin/pospal/up',
    method: 'post',
    data
  })
}


export function pospalActive(data) {
  return request({
    url: '/admin/pospal/active',
    method: 'get',
    params: data
  })
}

export function pospalLock(data) {
  return request({
    url: '/admin/pospal/lock',
    method: 'get',
    params: data
  })
}


// 获取供应商余额
export function supplierMoneyGetMoney(data) {
  return request({
    url: '/admin/supplier_money/getMoney',
    method: 'get',
    params: data
  })
}

// 获取客户余额
export function customerMoneyGetMoney(data) {
  return request({
    url: '/admin/customer_money/getMoney',
    method: 'get',
    params: data
  })
}

export function refGlobal(data) {
  return request({
    url: '/admin/shop/refGlobal',
    method: 'get',
    params: data
  })
}

// 微信用户接口
export function wxGetList(data) {
  return request({
    url: '/admin/wx/getlist',
    method: 'get',
    params: data
  })
}

export function wxGetOne(data) {
  return request({
    url: '/admin/wx/getOne',
    method: 'get',
    params: data
  })
}

export function wxAddOne(data) {
  return request({
    url: '/admin/wx/add',
    method: 'post',
    data
  })
}

export function wxDelOne(data) {
  return request({
    url: '/admin/wx/del',
    method: 'get',
    params: data
  })
}

export function wxLockOne(data) {
  return request({
    url: '/admin/wx/lock',
    method: 'get',
    params: data
  })
}

export function wxActiveOne(data) {
  return request({
    url: '/admin/wx/active',
    method: 'get',
    params: data
  })
}

export function wxUpOne(data) {
  return request({
    url: '/admin/wx/up',
    method: 'post',
    data
  })
}

// 修改商户金额
export function upMoney(data) {
  return request({
    url: '/admin/company_account/addMoney',
    method: 'post',
    data
  })
}

export function addTransMoney(data) {
  return request({
    url: '/admin/order_sell/add_trans_money',
    method: 'get',
    params: data
  })
}

export function addTransMoney_orderBuy(data) {
  return request({
    url: '/admin/order_buy/add_trans_money',
    method: 'get',
    params: data
  })
}

export function addmoveTransMoney(data) {
  return request({
    url: '/admin/order_move/add_trans_money',
    method: 'get',
    params: data
  })
}

export function shouldPayGetInfo(data) {
  return request({
    url: '/admin/should_pay/getInfo',
    method: 'get',
    params: data
  })
}

// 打印接口
export function PrintCode(data) {
  return request({
    url: '/admin/Printer/PrintCode',
    method: 'post',
    data
  })
}

// 溯源列表
export function getltemWayInfo(data) {
  return request({
    url: '/admin/PublicAPI/getItemWayInfo',
    method: 'get',
    params: data
  })
}


// 群聊设置
export function wechatRoomList(data) {
  return request({
    url: '/admin/wechat_room/list',
    method: 'post',
    data
  })
}

// 删除
export function wechatRoomDelete(data) {
  return request({
    url: '/admin/wechat_room/delete',
    method: 'post',
    data
  })
}

// 获取可选字段
export function getFieldList(data) {
  return request({
    url: '/admin/wechat_room/get_field_list',
    method: 'get',
    params: data
  })
}

// 建群接口
export function wechatRoomExposeCreate(data) {
  return request({
    url: '/admin/Wechat_room_expose/create',
    method: 'post',
    data
  })
}

export function wechatRoomUpdate(data) {
  return request({
    url: '/admin/wechat_room/update',
    method: 'post',
    data
  })
}

export function wechatRoomDetail(data) {
  return request({
    url: '/admin/wechat_room/detail',
    method: 'get',
    params: data
  })
}



// WEBPACK FOOTER //
// ./src/api/base.js